/**
 * useWorkspaceConfig Hook
 * 
 * Lädt und cached die Workspace-Konfiguration.
 * 
 * Migration: Custom Instructions → Custom Presets
 * - Normalisiert beide Feld-Namen für Backwards-Compatibility
 */

import { useQuery } from '@tanstack/react-query';
import { getWorkspaceConfig } from '@/lib/api/workspace';
import type { WorkspaceConfig } from '@/types';

export function useWorkspaceConfig() {
  const query = useQuery({
    queryKey: ['workspace', 'config'],
    queryFn: async () => {
      const response = await getWorkspaceConfig();
      const config = response.config;
      
      // Normalisiere: Stelle sicher dass beide Felder vorhanden sind
      // Neue Felder haben Priorität
      if (!config.custom_presets && config.custom_instructions) {
        config.custom_presets = config.custom_instructions;
      }
      if (config.can_use_custom_presets === undefined && config.can_use_custom_instructions !== undefined) {
        config.can_use_custom_presets = config.can_use_custom_instructions;
      }
      
      // Legacy-Felder auch setzen falls nur neue vorhanden
      if (!config.custom_instructions && config.custom_presets) {
        config.custom_instructions = config.custom_presets;
      }
      if (config.can_use_custom_instructions === undefined && config.can_use_custom_presets !== undefined) {
        config.can_use_custom_instructions = config.can_use_custom_presets;
      }
      
      return config;
    },
    staleTime: 2 * 60 * 1000, // 2 Minuten
  });

  return {
    config: query.data as WorkspaceConfig | undefined,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}

export default useWorkspaceConfig;
